import { ReactNode } from 'react';

import { Label } from '@/components/ui/label';

import Description from './description';
import { FormFieldError } from './form-field-error';

export function FieldShell({
  label,
  required,
  description,
  hideLabel,
  labelAddon,
  error,
  children,
}: {
  label: string;
  required: boolean;
  description?: string | null;
  hideLabel?: boolean;
  // Lays the label out as a row with this beside it; pass null to keep the row with nothing beside the label.
  labelAddon?: ReactNode;
  error?: string;
  children: ReactNode;
}) {
  const labelElement = !hideLabel && !!label && <Label required={required}>{label}</Label>;

  return (
    <div className="space-y-1">
      {labelAddon === undefined
        ? labelElement
        : (labelElement || labelAddon) && (
            <div className="flex items-center gap-1">
              {labelElement}
              {labelAddon}
            </div>
          )}
      {description && <Description content={description} />}
      {children}
      <FormFieldError error={error} />
    </div>
  );
}
